import React from 'react';
import { SpcCheckoutHeader } from '../header/SpcCheckoutHeader';
import styled from 'styled-components';
import { useTermsPrivacy } from '../../../hooks/terms-privacy/useTermsPrivacy';
import { XButton, XGrid } from '@orderx/lab/ui';

const Wrapper = styled(XGrid)`
    .terms-container {
        height: 300px;
        overflow: auto;
    }
`;

interface Props {
    termsAndConditions: string;
    privacyPolicy: string;
    totalCost: number;
    isLoading: boolean;

    onNext(): any;

    onClose(): void;
}

export function SpcCheckoutAcceptTerms({
    termsAndConditions,
    privacyPolicy,
    totalCost,
    isLoading,
    onNext,
    onClose,
}: Props) {
    const { accept, htmlTermsAndConditions, htmlPrivacyPolicy } = useTermsPrivacy();

    return (
        <Wrapper>
            <SpcCheckoutHeader totalCost={totalCost} onClose={onClose} />

            <div
                className="terms-container"
                dangerouslySetInnerHTML={{
                    __html: [termsAndConditions || htmlTermsAndConditions, privacyPolicy || htmlPrivacyPolicy].join(''),
                }}
            />

            <XButton
                onClick={() => {
                    accept();
                    onNext();
                }}
                isLoading={isLoading}
                color="primary"
                className={'cta'}>
                I accept
            </XButton>
        </Wrapper>
    );
}
